var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CookiesService } from "./cookies.service";
var LmApiService = /** @class */ (function () {
    function LmApiService(http, cookieService) {
        this.http = http;
        this.cookieService = cookieService;
        this.adminOnlyQueryParamCookies = ["pmc"];
        this.optionalQueryParamCookies = ["user_content_permission", "logged_in"];
        this.apiKey = window.PBSLM.NG.API_KEY;
        this._adminDisplay = window.PBSLM.NG.ADMIN_DISPLAY;
        this._isSU = window.PBSLM.NG.IS_SU;
    }
    LmApiService.prototype.userHasAdminDisplay = function () {
        // This is duplicate functionality of UserService.hasAdminDisplay() to avoiding circular dependency
        return this._adminDisplay || this._isSU;
    };
    LmApiService.prototype.makeAPIUrl = function (url) {
        if (url.startsWith("http://") || url.startsWith("https://"))
            return url;
        if (url.startsWith("/"))
            url = url.slice(1);
        return window.PBSLM.NATIONAL_SITE_URL + url;
    };
    LmApiService.prototype.get = function (url, params) {
        if (params === void 0) { params = {}; }
        this.setHeaders(params);
        return this.http.get(url, params);
    };
    LmApiService.prototype.post = function (url, data, params) {
        if (params === void 0) { params = {}; }
        this.setHeaders(params);
        return this.http.post(url, data, params);
    };
    LmApiService.prototype.put = function (url, data, params) {
        if (params === void 0) { params = {}; }
        this.setHeaders(params);
        return this.http.put(url, data, params);
    };
    LmApiService.prototype.delete = function (url, params) {
        if (params === void 0) { params = {}; }
        this.setHeaders(params);
        return this.http.delete(url, params);
    };
    LmApiService.prototype.getWithCookiesInParams = function (url, cookiesToSend, params) {
        if (cookiesToSend === void 0) { cookiesToSend = []; }
        if (params === void 0) { params = {}; }
        url = this.makeAPIUrl(url);
        cookiesToSend = this.addAdminCookies(cookiesToSend);
        url = this.sendCookiesAsQueryParams(url, cookiesToSend);
        this.setHeaders(params);
        return this.http.get(url, params);
    };
    LmApiService.prototype.getWithCookiesInParamsAll = function (url, params) {
        if (params === void 0) { params = {}; }
        var cookiesToSend = this.optionalQueryParamCookies;
        cookiesToSend = this.addAdminCookies(cookiesToSend);
        url = this.makeAPIUrl(url);
        url = this.sendCookiesAsQueryParams(url, cookiesToSend);
        this.setHeaders(params);
        return this.http.get(url, params);
    };
    // if params contain headers they should be plain object because get converts them to HttpHeaders
    LmApiService.prototype.setHeaders = function (params) {
        var headAuth = {
            Authorization: "Bearer " + this.apiKey,
        };
        if (params.headers) {
            params.headers = __assign({}, headAuth, params.headers);
        }
        else {
            params.headers = headAuth;
        }
        params.headers = new HttpHeaders(params.headers);
    };
    LmApiService.prototype.addAdminCookies = function (cookiesToSend) {
        if (this.userHasAdminDisplay()) {
            cookiesToSend = cookiesToSend.concat(this.adminOnlyQueryParamCookies);
        }
        return cookiesToSend;
    };
    LmApiService.prototype.sendCookiesAsQueryParams = function (url, cookies) {
        var _this = this;
        if (url.indexOf("?") == -1) {
            url += "?";
        }
        cookies.forEach(function (cookie_name) {
            var cookie = _this.cookieService.getCookie(cookie_name);
            if (cookie && cookie.value) {
                if (!url.endsWith("?")) {
                    url += "&";
                }
                url += "cookie:" + cookie.key + "=" + cookie.value;
            }
        });
        if (url.endsWith("?")) {
            // no actual cookie was added
            url = url.slice(0, -1);
        }
        return url;
    };
    return LmApiService;
}());
export { LmApiService };
